import { render } from "./ProjectSnapshot.vue?vue&type=template&id=79fa8432"
import script from "./ProjectSnapshot.vue?vue&type=script&lang=js"
export * from "./ProjectSnapshot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__